import { WhyBettySectionType } from './WhyBettySection.types'

export const WhyBetty: WhyBettySectionType[] = [
  {
    imgSrc: 'landingPage.canada',
    title: 'Made for Ontario Players',
  },
  {
    imgSrc: 'landingPage.stopWatch',
    title: 'Instant Withdrawals',
  },
  {
    imgSrc: 'landingPage.successWithdraw',
    title: 'Cash Out Anytime',
  },
  {
    imgSrc: 'landingPage.piggyBank',
    title: '$1 Minimum Deposit',
  },
]
